import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/index';
import convertNameToLingvoStep from '@/helpers/convertNameToLingvoStep';

Vue.use(VueRouter);

// Paths

export const paths = Object.freeze({
  admin: '/admin',
  refund: '/refund',
  home: '/',
  events: '/events',
  performance: '/performance',
  chooseSeat: '/choose-seat',
  buyForm: '/buy-form',
  payInstruction: '/pay-instruction',
  sendTicket: '/send-ticket',
  cart: '/cart',
  feedback: '/feedback',
  feedbackEvents: '/feedback-events',
  feedbackPerformance: '/feedback-performance',
  rateEvent: '/rate-event',
  videoInstruction: '/video-instruction',
  takeVideo: '/take-video',
  sendVideo: '/send-video',
  audioInstruction: '/audio-instruction',
  takeAudio: '/take-audio',
  sendAudio: '/send-audio',
  entertainment: '/entertainment',
  takePhoto: '/take-photo',
  sendPhoto: '/send-photo',
});

// Routes

export const routes = [
  {
    path: paths.admin,
    name: 'Admin',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Admin.vue'),
    meta: {
      back: false,
      home: true,
      cart: false,
      footer: true,
    },
  },
  {
    path: paths.refund,
    name: 'Refund',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Refund.vue'),
    meta: {
      back: paths.admin,
      home: true,
      cart: false,
      footer: true,
    },
  },
  {
    path: paths.home,
    name: 'Home',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Home.vue'),
    meta: {
      back: false,
      home: false,
      cart: true,
      footer: true,
    },
  },
  {
    path: paths.cart,
    name: 'Cart',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Cart.vue'),
    meta: {
      back: false,
      home: true,
      cart: false,
      footer: true,
    },
  },
  {
    path: paths.events,
    name: 'Events',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Events.vue'),
    meta: {
      back: paths.home,
      home: true,
      cart: true,
      footer: true,
    },
  },
  {
    path: paths.performance,
    name: 'Performance',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Performance.vue'),
    meta: {
      back: paths.events,
      home: true,
      cart: false,
      footer: true,
    },
  },
  {
    path: paths.chooseSeat,
    name: 'ChooseSeat',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/ChooseSeat.vue'),
    meta: {
      back: paths.events,
      home: true,
      cart: true,
      footer: true,
    },
  },
  {
    path: paths.buyForm,
    name: 'BuyForm',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/BuyForm.vue'),
    meta: {
      back: paths.cart,
      home: true,
      cart: false,
      footer: true,
    },
  },
  {
    path: paths.payInstruction,
    name: 'PayInstruction',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/PayInstruction.vue'),
    meta: {
      back: paths.cart,
      home: true,
      cart: false,
      footer: true,
    },
  },
  {
    path: paths.sendTicket,
    name: 'SendTicket',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/SendTicket.vue'),
    meta: {
      back: false,
      home: false,
      cart: false,
      footer: true,
    },
  },
  {
    path: paths.feedback,
    name: 'Feedback',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Feedback.vue'),
    meta: {
      back: paths.home,
      home: true,
      cart: true,
      footer: true,
    },
  },
  {
    path: paths.feedbackEvents,
    name: 'ChooseEvent',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/FeedbackEvents.vue'),
    meta: {
      back: paths.feedback,
      home: true,
      cart: true,
      footer: true,
    },
  },
  {
    path: paths.feedbackPerformance,
    name: 'FeedbackPerformance',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/FeedbackPerformance.vue'),
    meta: {
      back: paths.feedbackEvents,
      home: true,
      cart: true,
      footer: true,
    },
  },
  {
    path: paths.rateEvent,
    name: 'RateEvent',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/RateEvent.vue'),
    meta: {
      back: paths.feedbackEvents,
      home: true,
      cart: true,
      footer: true,
    },
  },
  {
    path: paths.videoInstruction,
    name: 'VideoInstruction',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/VideoInstruction.vue'),
    meta: {
      back: paths.feedbackEvents,
      home: true,
      cart: true,
      footer: true,
    },
  },
  {
    path: paths.takeVideo,
    name: 'TakeVideo',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/TakeVideo.vue'),
    meta: {
      back: paths.feedbackEvents,
      home: true,
      cart: false,
      footer: false,
    },
  },
  {
    path: paths.sendVideo,
    name: 'SendVideo',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/SendVideo.vue'),
    meta: {
      back: paths.feedbackEvents,
      home: true,
      cart: false,
      footer: true,
    },
  },
  {
    path: paths.audioInstruction,
    name: 'AudioInstruction',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/AudioInstruction.vue'),
    meta: {
      back: paths.feedback,
      home: true,
      cart: true,
      footer: true,
    },
  },
  {
    path: paths.takeAudio,
    name: 'TakeAudio',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/TakeAudio.vue'),
    meta: {
      back: paths.feedback,
      home: true,
      cart: false,
      footer: true,
    },
  },
  {
    path: paths.sendAudio,
    name: 'SendAudio',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/SendAudio.vue'),
    meta: {
      back: paths.feedback,
      home: true,
      cart: false,
      footer: true,
    },
  },
  {
    path: paths.entertainment,
    name: 'Entertainment',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Entertainment.vue'),
    meta: {
      back: paths.home,
      home: true,
      cart: true,
      footer: true,
    },
  },
  {
    path: paths.takePhoto,
    name: 'TakePhoto',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/TakePhoto.vue'),
    meta: {
      back: paths.home,
      home: true,
      cart: false,
      footer: false,
    },
  },
  {
    path: paths.sendPhoto,
    name: 'SendPhoto',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/SendPhoto.vue'),
    meta: {
      back: paths.takePhoto,
      home: true,
      cart: false,
      footer: true,
    },
  },
];

// Router

function createRouterWithRobot(robot) {
  const router = new VueRouter({
    linkActiveClass: '_active',
    linkExactActiveClass: '_active_exact',
    paths,
    routes,
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });

  router.beforeEach((to, from, next) => {
    const fromIndex = routes.findIndex((route) => route.path === from.path);
    const toIndex = routes.findIndex((route) => route.path === to.path);
    store.commit('setMoveFlag', fromIndex > toIndex);

    const replicName = convertNameToLingvoStep(to.name, 'screen');

    robot.dialogService.setCase(replicName, true, true);
    robot.dialogService.sayReplicByName(replicName, true);

    next();
  });

  robot.dialogService.onAction((actions) => {
    for (let i = 0; i < actions.length; i += 1) {
      const action = actions[i];
      const routeByAction = routes
        .find((route) => convertNameToLingvoStep(route.name, 'actionTo') === action);
      if (routeByAction) {
        router.push(routeByAction.path);
        break;
      }
    }
  });

  return router;
}

export default createRouterWithRobot;
